import { render } from "./LearnerProfileForm.vue?vue&type=template&id=21f5069e&scoped=true"
import script from "./LearnerProfileForm.vue?vue&type=script&lang=js"
export * from "./LearnerProfileForm.vue?vue&type=script&lang=js"

import "./LearnerProfileForm.vue?vue&type=style&index=0&id=21f5069e&scoped=true&lang=css"

import exportComponent from "/vercel/path0/frontend/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-21f5069e"]])

export default __exports__